export default __webpack_public_path__ + "static/front_img_3-ce0c64e4742bb00a3d0c7b92bdcd6f1b.png";